export default class EventDispatcher {
    #logger;
    #errorLogger;
    #lastLoggedError = '';
    #videoOutputManager;
    #streamStateManager;

    constructor(logger, errorLogger, videoOutputManager, streamStateManager) {
        this.#logger = logger;
        this.#errorLogger = errorLogger;
        this.#videoOutputManager = videoOutputManager;
        this.#streamStateManager = streamStateManager;
    }

    dispatch(source, detail, videoOutputId) {
        this.#logger(`EventDispatcher: ${source} → videoStreamState`, detail);
        this.#handleStreamStateEvent(detail, videoOutputId);
    }

    #handleStreamStateEvent(detail, videoOutputId) {
        const updatedState = this.#streamStateManager.updateStateOnly(detail);

        this.#dispatchToDOM(
            'videoStreamState',
            {
                ...updatedState,
                updateSourceState: (detail) => this.#handleExternalStateUpdate(detail),
            },
            videoOutputId
        );
    }

    #handleExternalStateUpdate(detail) {
        const updatedState = this.#streamStateManager.updateStateOnly(detail);
        this.#dispatchToDOM('videoStreamState', updatedState);
    }

    #dispatchToDOM(type, detail, videoOutputId) {
        const event = new CustomEvent(type, { detail });

        const videoOutputIds = videoOutputId ? [videoOutputId] : this.#videoOutputManager.getVideoOutputIds();

        if (videoOutputIds.length) {
            let dispatched = false;
            videoOutputIds.forEach((outputId) => {
                const videoOutput = document.getElementById(outputId);
                if (!videoOutput) {
                    this.#logger(`EventDispatcher: VideoOutputId= "${outputId}" not found`);
                    return;
                }

                videoOutput.dispatchEvent(event);
                dispatched = true;

                // Log dispatched event
                if (type === 'videoStreamState') {
                    const dispatching = Object.keys(detail)
                        .map((key) => ` [${key}:${detail[key]}]`)
                        .toString();
                    this.#logger(`EventDispatcher: Target "${outputId}" type="${type}" detail:{${dispatching}}`);
                }
            });

            const error = detail?.error || '';

            if (!error) {
                this.#lastLoggedError = '';
            }

            if (dispatched && error && error !== this.#lastLoggedError) {
                this.#errorLogger(`[STREAM ERROR]: "${error}"`);
                this.#lastLoggedError = error;
            }
        }
    }

    dispatchStreamState(detail, videoOutputId) {
        this.dispatch('StreamStateManager', detail, videoOutputId);
    }
}
